import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { HashRouter } from 'react-router-dom';
import './assets/styles/base.scss';
import 'sweetalert/dist/sweetalert.css';
import Main from './pages/Main';
import configureStore from './config/configureStore';
import { Provider } from 'react-redux';
import { getTeams, updateLiveScores } from './actions';
import ReactGA from 'react-ga';
import {API_URL} from "components/Constants"; // Import API_URL
// import 'bootstrap/dist/css/bootstrap.min.css';

ReactGA.initialize('UA-136346136-1');

const store = configureStore();
const rootElement = document.getElementById('root');


const teams =  [
  {id: 1, name: "Avenel 1", caption: 'Caption 1'},
  {id: 2, name: "Avenel 2", caption: 'Caption 1'},
  {id: 3, name: "Avenel 3", caption: 'Caption 1'},
  {id: 4, name: "Edison 1", caption: 'Caption 1'},
  {id: 5, name: "Edison 2", caption: 'Caption 1'},
  {id: 6, name: "Edison 2", caption: 'Caption 1'},
  {id: 7, name: "Edison 2", caption: 'Caption 1'},
  {id: 8, name: "Edison 2", caption: 'Caption 1'},
  {id: 9, name: "Edison 2", caption: 'Caption 1'},
  {id: 10, name: "Edison 2", caption: 'Caption 1'},
  {id: 11, name: "Edison 2", caption: 'Caption 1'},
  {id: 12, name: "Edison 2", caption: 'Caption 1'},
  {id: 13, name: "Edison 2", caption: 'Caption 1'},
  {id: 14, name: "Edison 2", caption: 'Caption 1'},
  {id: 15, name: "Edison 2", caption: 'Caption 1'},
  {id: 16, name: "Edison 2", caption: 'Caption 1'},        
];

store.dispatch(getTeams(teams));
 
setInterval(() => 
  fetch(`${API_URL}/app/api/v1/games?filter=status==A`)
    .then(results => results.json()).then(resp => {
      store.dispatch(updateLiveScores(resp));
      },err => {
      })
  , 
  3000
);
 

const renderApp = Component => {  
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Component />
      </HashRouter>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept('./pages/Main', () => {
    const NextApp = require('./pages/Main').default
    renderApp(NextApp);
  });
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js